<script>
    import { fade } from 'svelte/transition';
    import { beforeNavigate, afterNavigate } from '$app/navigation';

    $: beforeNav = false;

    beforeNavigate(() => {
        beforeNav = true;
    });

    afterNavigate(() => {
        beforeNav = false;
    });
    // Catch glitches
    setTimeout(() => {
        beforeNav = false;
    }, 10000);
</script>

{#if beforeNav}
    <div class="fixed top-[5%] z-50 flex w-full justify-center">
        <div class="items-center rounded-full bg-white/80 p-2 shadow-md dark:bg-base-700/80" in:fade={{ delay: 100, duration: 200 }}>
            <div
                class="block h-6 w-6 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] text-primary motion-reduce:animate-[spin_1.5s_linear_infinite] dark:text-white"
                role="status"
            >
                <span class="!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]">Loading...</span>
            </div>
        </div>
    </div>
{/if}
